module.exports = __webpack_public_path__ + "img/cert_2.d8524145.jpg";